const UI_PREFERENCE_KEY = "cirrom-preferred-ui";
const UI_COMBINED_RECORD_MODAL_KEY = "cirrom-use-combined-record-modal";

type UIPreference = "product" | "app";

const VALID_PREFERENCES: UIPreference[] = ["product", "app"];
const DEFAULT_PREFERENCE: UIPreference = "product";

export function getPreferredUI(): UIPreference {
  const stored = localStorage.getItem(UI_PREFERENCE_KEY);
  if (stored && VALID_PREFERENCES.includes(stored as UIPreference)) {
    return stored as UIPreference;
  }
  if (stored !== null) {
    localStorage.removeItem(UI_PREFERENCE_KEY);
  }
  return DEFAULT_PREFERENCE;
}

export function setPreferredUI(preference: UIPreference): void {
  localStorage.setItem(UI_PREFERENCE_KEY, preference);
}

export function getPreferredDashboardPath(): string {
  return getPreferredUI() === "product"
    ? "/product/dashboard"
    : "/app/dashboard";
}

export const displayCombinedRecordModal = (): boolean => {
  const stored = localStorage.getItem(UI_COMBINED_RECORD_MODAL_KEY);
  if (stored) {
    return stored === "true";
  }
  return false;
};

export const toggleCombinedRecordModal = (): void => {
  localStorage.setItem(
    UI_COMBINED_RECORD_MODAL_KEY,
    (!displayCombinedRecordModal()).toString()
  );
};
